import { Box, Step, StepLabel, Stepper } from '@mui/material'
import type { JSX } from 'react'
import { useCallback, useMemo, useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { layoutStyles } from '@/utils/theme'

import {
  initialSelectedDevicesState,
  SelectedDevicesContext,
  selectedDevicesReducer,
} from './reducers'
import SelectDeviceForOutOfServiceStep from './SelectDeviceStep'
import TakeOutOfServiceStep from './TakeOutOfServiceStep'

export const DeviceTakingOutOfService = (): JSX.Element => {
  const { t } = useTranslation(['app'])
  const [activeStep, setActiveStep] = useState(0)
  const [selectedDevicesState, selectedDevicesDispatch] = useReducer(
    selectedDevicesReducer,
    initialSelectedDevicesState,
  )

  const selectedDevicesContextValue = useMemo(
    () => ({
      state: selectedDevicesState,
      dispatch: selectedDevicesDispatch,
    }),
    [selectedDevicesState, selectedDevicesDispatch],
  )
  const stepLabels = useMemo(
    () => [
      { name: t('device.inService.selectDevices') },
      { name: t('device.inService.takeOutOfService') },
    ],
    [t],
  )
  const handleStepChange = useCallback((step: number) => {
    setActiveStep(step)
  }, [])
  return (
    <SelectedDevicesContext.Provider value={selectedDevicesContextValue}>
      <Box
        sx={{
          ...layoutStyles.pageContainer,

          mt: 0,
          p: 3,
        }}
        id={'page-container-box-for-take-out '}
      >
        <Box
          sx={{ width: '100%' }}
          id={'select-devices-to-take-out-of-service'}
        >
          <Stepper activeStep={activeStep} alternativeLabel>
            {stepLabels.map((label) => (
              <Step key={label.name}>
                <StepLabel>{label.name}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 4, position: 'relative', overflow: 'hidden' }}>
            <Box
              sx={{
                transform: `translateX(-${activeStep * 100}%)`,
                transition: 'transform 0.3s ease-in-out',
                display: 'flex',
              }}
            >
              <Box sx={{ width: '100%', flexShrink: 0 }}>
                <SelectDeviceForOutOfServiceStep
                  setActiveStep={handleStepChange}
                />
              </Box>
              <Box sx={{ width: '100%', flexShrink: 0 }}>
                <TakeOutOfServiceStep setActiveStep={handleStepChange} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </SelectedDevicesContext.Provider>
  )
}
export default DeviceTakingOutOfService
